import React, { useMemo, useState, useEffect } from 'react'
import cz from 'classnames';
import {
  Card,
  Flex,
  WingBlank,
  Button,
  WhiteSpace,
  List,
  Toast,
  Tag,
} from 'antd-mobile'
import { useRequest } from 'ahooks'
import useGlobalLoading from '@/hooks/useGlobalLoading'
import {
  getAccountInfo,
  getRedpacketDetail,
  getOrderDetail,
  exchangeRedpacket,
} from '@/service/account'
import Container from '@/components/Container'
import FullModal from '@/components/FullModal'
import ListItem from '@/components/ListItem'
import Clipboard from '@/components/Clipboard'
import FailMessage from '@/components/FailMessage'
import TrackContainer from '@/components/TrackContainer'
import IconFont from '@/components/IconFont'
import RedDetail from './RedDetail'
import { dispatchSDK } from '@/utils/extend'
import { IAccount, IRedpacket, IOrder } from './index.d'
import styles from './style.module.scss'

let timer: NodeJS.Timeout

const Account = () => {
  // 红包明细modal
  const [visible, setVisible] = useState<boolean>(false)
  // 订单明细modal
  const [orderVisible, setOrderVisible] = useState<boolean>(false)
  // 绑定微信modal
  const [bindVisible, setBindVisible] = useState<boolean>(false)
  // 红包兑换modal
  const [exchangeVisible, setExchangeVisible] = useState<boolean>(false)
  const [exchangeValue, setExchangeValue] = useState<number>()
  // debug 点击计数
  // const [clickCount, setClickCount] = useState<number>(0)
  const {
    data: account,
    loading: accountLoading,
    run: fetchAccountInfo,
  } = useRequest<IAccount>(getAccountInfo)
  const { data: reds, run: fetchReds, loading: redLodaing } = useRequest<
    IRedpacket
  >(getRedpacketDetail, {
    manual: true,
  })
  const { data: orders, run: fetchOrders, loading: orderLoading } = useRequest<
    IOrder
  >(getOrderDetail, {
    manual: true,
  })

  useGlobalLoading([accountLoading, redLodaing, orderLoading])

  // memo data
  const accountMemo = useMemo(() => {
    const mData = account || {
      data: {
        account: '',
        alias: '',
        bind_code: '',
        mobile: '',
        nick_name: '',
        redpacket: '',
        avatar: '',
        is_bind_mobile: 0,
        is_bind_weixin: 0,
        is_cert: 0,
        kefu: {
          qq: '',
          weixin: '',
          contact_kefu: '',
        },
        my: {
          account: true,
          kefu: true,
          redpacket: true,
          weixin: true,
          order: true,
        },
        exchange_money_item: [] as number[],
      },
    }
    return mData.data
  }, [account])

  const redMemo = useMemo(() => {
    return reds?.data || []
  }, [reds])

  const ordersMemo = useMemo(() => {
    return orders?.data || []
  }, [orders])

  const switchAccount = () => {
    dispatchSDK('changeLogin')
  }

  const realName = () => {
    dispatchSDK('certification')
  }

  const changePass = () => {
    dispatchSDK('changePassword')
  }

  // 打开红包弹窗
  const openExchangeModal = () => {
    const { is_bind_mobile, is_bind_weixin } = accountMemo
    const hasBindWXAndPhone = is_bind_weixin && is_bind_mobile
    if (!hasBindWXAndPhone) {
      return Toast.show(
        <FailMessage>绑定微信和手机号才能兑换红包哦~</FailMessage>,
        2
      )
    }
    // TODO 下版本做：弹窗形式改为面板展示
    // if (exchange_money_item.length) {
    //   const [minimumValue] = exchange_money_item;
    //   if (Number(redpacket) < minimumValue) {
    //     return Toast.fail('绑定微信和手机号才能兑换红包哦~')
    //   }
    // }
    setExchangeVisible(true)
  }

  // 兑换红包
  const doExchange = async () => {
    if (!exchangeValue) {
      return Toast.show(<FailMessage>请选择要兑换的红包金额</FailMessage>)
    }
    await exchangeRedpacket({
      exchange_money_item: exchangeValue,
    })
    Toast.success('红包兑换成功，请前往微信账户查看~', 2, () => {
      fetchAccountInfo()
    })
  }

  const openBindWechatModal = () => {
    dispatchSDK('bindWX')
    // setBindVisible(true)
  }

  const goWechat = () => {
    dispatchSDK('share', 'weixin')
  }

  const bindPhone = () => {
    dispatchSDK('bindPhone')
  }

  const checkRedpacket = async () => {
    await fetchReds()
    setVisible(true)
  }

  const checkOrders = async () => {
    await fetchOrders()
    setOrderVisible(true)
  }

  const contactKefu = () => {
    dispatchSDK('openBrowser', accountMemo.kefu.contact_kefu)
  }

  const editNickname = () => {
    dispatchSDK('setAccountAlias')
  }

  // 3s内点击5次
  // const openDebug = (e: any) => {
  //   e.stopPropagation()
  //   clearTimeout(timer)
  //   if (clickCount === 5) {
  //     console.log('触发')
  //     dispatchSDK('resetLogFlag')
  //   }
  //   setClickCount(clickCount + 1);
  //   timer = setTimeout(() => {
  //     setClickCount(0)
  //   }, 3000);
  // };

  const username = useMemo(() => {
    const { account, alias } = accountMemo
    return alias || account
  }, [accountMemo])

  useEffect(() => {
    return () => {
      clearTimeout(timer)
    }
  }, [])

  return (
    <div className="page">
      {/* 账号 */}
      {accountMemo.my.account && (
        <>
          <Card>
            <Card.Header
              title={
                <div>
                  <IconFont className="icon" name="zhanghaoqufu" />
                  我的账号
                </div>
              }
              extra={
                <TrackContainer trackId="h5_switch_account">
                  <button
                    className="pure-btn color-orange"
                    onClick={switchAccount}
                  >
                    切换账号
                  </button>
                </TrackContainer>
              }
            />
            <Card.Body className="with-padding">
              {username && (
                <Flex>
                  <div className="overflow-ellipsis">
                    <b style={{ marginRight: 10 }}>{username}</b>
                    {!accountMemo.alias && (
                      <TrackContainer trackId="h5_edit_nickname">
                        <button
                          className="pure-btn color-orange"
                          onClick={editNickname}
                        >
                          修改
                        </button>
                      </TrackContainer>
                    )}
                  </div>
                </Flex>
              )}

              <Flex wrap="wrap">
                <Flex.Item style={{ minWidth: '100px' }}>
                  <div className={styles.phone}>
                    {accountMemo.is_bind_mobile || accountLoading ? (
                      accountMemo.mobile
                    ) : (
                      <TrackContainer trackId="h5_bind_phone">
                        <button className="pure-btn" onClick={bindPhone}>
                          <span className="overflow-ellipsis color-primary">
                            请点击绑定手机
                          </span>
                        </button>
                      </TrackContainer>
                    )}
                  </div>
                </Flex.Item>
                <Flex>
                  <WingBlank size="sm">
                    <TrackContainer trackId="h5_certification">
                      <Button
                        style={
                          {
                            // width: 78,
                          }
                        }
                        className="round"
                        type="ghost"
                        size="small"
                        onClick={realName}
                        disabled={Boolean(accountMemo.is_cert)}
                      >
                        {accountMemo.is_cert ? '已实名认证' : '实名认证'}
                      </Button>
                    </TrackContainer>
                  </WingBlank>
                  <WingBlank size="sm">
                    <TrackContainer trackId="h5_alter_password">
                      <Button
                        className="round"
                        size="small"
                        type="primary"
                        onClick={changePass}
                      >
                        修改密码
                      </Button>
                    </TrackContainer>
                  </WingBlank>
                </Flex>
              </Flex>
            </Card.Body>
          </Card>
          <WhiteSpace size="lg" />
        </>
      )}
      {/* 红包 */}
      {accountMemo.my.redpacket && (
        <>
          <Card>
            <Card.Header
              title={
                <div>
                  <IconFont className="icon" name="hongbao" />
                  我的红包
                </div>
              }
            ></Card.Header>
            <Card.Body className="with-padding">
              <Flex wrap="wrap">
                <Flex.Item style={{ minWidth: '100px' }}>
                  <span className={styles.amount}>
                    {Number(accountMemo.redpacket).toFixed(2) || 0}{' '}
                    <span className="text-md">元</span>
                  </span>
                </Flex.Item>
                <Flex>
                  <WingBlank size="sm">
                    <TrackContainer trackId="h5_redpacket_details">
                      <Button
                        className="round"
                        type="ghost"
                        size="small"
                        onClick={checkRedpacket}
                      >
                        红包明细
                      </Button>
                    </TrackContainer>
                  </WingBlank>
                  <WingBlank size="sm">
                    <TrackContainer trackId="h5_exchange">
                      <Button
                        className="round"
                        size="small"
                        type="primary"
                        onClick={openExchangeModal}
                      >
                        立即兑换
                      </Button>
                    </TrackContainer>
                  </WingBlank>
                </Flex>
              </Flex>
            </Card.Body>
          </Card>
          <WhiteSpace size="lg" />
        </>
      )}
      {/* 微信 */}
      {accountMemo.my.weixin && (
        <>
          <Card>
            <Card.Header
              title={
                <div>
                  <IconFont className="icon" name="weixin1" />
                  我的微信
                </div>
              }
            ></Card.Header>
            <Card.Body className="with-padding">
              <Flex style={{ minHeight: 40 }}>
                {accountMemo.avatar && (
                  <div className={styles.avatar}>
                    <img src={accountMemo.avatar} alt="avatar" />
                  </div>
                )}
                <Flex.Item>
                  {Boolean(accountMemo.nick_name) && (
                    <span className={styles.name}>{accountMemo.nick_name}</span>
                  )}
                  {!Boolean(accountMemo.is_bind_weixin) && (
                    <div>
                      微信号：<span className="color-gray">未绑定</span>
                    </div>
                  )}
                </Flex.Item>
                <TrackContainer trackId="h5_bind_wx">
                  <Button
                    disabled={Boolean(accountMemo.is_bind_weixin)}
                    size="small"
                    className="round"
                    type={accountMemo.is_bind_weixin ? 'ghost' : 'primary'}
                    onClick={openBindWechatModal}
                  >
                    {accountMemo.is_bind_weixin ? '已经绑定' : '立即绑定'}
                  </Button>
                </TrackContainer>
              </Flex>
            </Card.Body>
          </Card>
          <WhiteSpace size="lg" />
        </>
      )}
      {/* 订单 */}
      {accountMemo.my.order && (
        <>
          <Card>
            <Card.Header
              title={
                <div>
                  <IconFont className="icon" name="dingdan" />
                  我的订单
                </div>
              }
            ></Card.Header>
            <Card.Body className="with-padding">
              <Flex>
                <Flex.Item></Flex.Item>
                <TrackContainer trackId="h5_indent_details">
                  <Button
                    className="round"
                    type="ghost"
                    size="small"
                    onClick={checkOrders}
                  >
                    订单明细
                  </Button>
                </TrackContainer>
              </Flex>
            </Card.Body>
          </Card>
          <WhiteSpace size="lg" />
        </>
      )}
      {/* 客服 */}
      {accountMemo.my.kefu && (
        <Card>
          <Card.Header
            title={
              <div>
                <IconFont className="icon" name="kefu" />
                客服中心
              </div>
            }
          ></Card.Header>
          <Card.Body className="with-padding">
            {accountMemo.kefu.qq && (
              <Flex>
                <Flex.Item>
                  <span className={styles.contact}>
                    客服QQ群：{accountMemo.kefu.qq}
                  </span>
                </Flex.Item>
                <Clipboard value={accountMemo.kefu.qq}>复制</Clipboard>
              </Flex>
            )}
            {accountMemo.kefu.weixin && (
              <Flex style={{ minHeight: 40 }}>
                <Flex.Item>
                  <span className={styles.contact}>
                    微信公众号：{accountMemo.kefu.weixin}
                  </span>
                </Flex.Item>
                <Clipboard
                  value={accountMemo.kefu.weixin}
                  onSuccess={() => {
                    Toast.success('复制成功，前往微信公众号关注')
                  }}
                >
                  复制
                </Clipboard>
              </Flex>
            )}
            <Flex justify="center">
              {accountMemo.kefu.contact_kefu && (
                <TrackContainer trackId="h5_contact_service">
                  <Button
                    className="round"
                    size="small"
                    type="primary"
                    onClick={contactKefu}
                  >
                    联系客服
                  </Button>
                </TrackContainer>
              )}
            </Flex>
          </Card.Body>
        </Card>
      )}
      {/* 红包明细弹窗 */}
      <FullModal
        visible={visible}
        title="红包明细"
        onClose={() => setVisible(false)}
      >
        <Container isEmpty={Boolean(!redMemo.length)}>
          <RedDetail data={redMemo} />
        </Container>
      </FullModal>
      {/* 订单明细弹窗 */}
      <FullModal
        visible={orderVisible}
        title="订单明细"
        onClose={() => setOrderVisible(false)}
      >
        <Container isEmpty={Boolean(!ordersMemo.length)}>
          <List>
            {ordersMemo.map((i, index) => (
              <ListItem
                key={`${i.time}_${index}`}
                title={i.order_no}
                subTitle={i.time}
                count={i.amount}
                status={i.status}
              />
            ))}
          </List>
        </Container>
      </FullModal>
      {/* 红包兑换弹窗 */}
      <FullModal
        title="红包兑换"
        visible={exchangeVisible}
        onClose={() => setExchangeVisible(false)}
        isList={false}
      >
        <div>
          <div>
            当前红包余额：
            <span className="color-danger text-md">
              <span className="text-lg">{accountMemo.redpacket}</span>元
            </span>
          </div>
          <div className={styles.tags}>
            {accountMemo.exchange_money_item.map((i) => (
              <div
                className={styles.tag}
                key={i}
                onClick={() => {
                  if (Number(accountMemo.redpacket) < i) {
                    Toast.show(
                      <FailMessage>{`账户余额不足${i}元`}</FailMessage>
                    )
                  }
                }}
              >
                <Tag
                  selected={exchangeValue === i}
                  onChange={(isSelected) => {
                    if (isSelected) {
                      setExchangeValue(i)
                    } else {
                      setExchangeValue(undefined)
                    }
                  }}
                  disabled={Number(accountMemo.redpacket) < i}
                >
                  {i}元
                </Tag>
              </div>
            ))}
          </div>
        </div>
        <WhiteSpace size="xl" />
        <div className={cz('color-gray text-sm', styles.tips)}>
          <span className="color-danger">温馨提示：</span>
          <p>1.若您当前兑换金额不足时，请持续完成游戏任务领取红包；</p>
          <p>2.我们会将您兑换的红包发放到您绑定的微信中；</p>
          <p>3.每次兑换金额不超过100元，每天不能超过2次。</p>
        </div>
        <WhiteSpace size="xl" />
        <Flex justify="center">
          <Button
            style={{ width: '100%' }}
            className="round"
            type="primary"
            size="small"
            onClick={doExchange}
          >
            兑换
          </Button>
        </Flex>
      </FullModal>
      {/* 绑定微信弹窗 */}
      <FullModal
        title="微信绑定步骤"
        visible={bindVisible}
        onClose={() => setBindVisible(false)}
        isList={false}
      >
        <div className={styles.steps}>
          <div>
            1、打开微信，搜索公众号“
            <span className="color-danger">爱玩SDK</span>
            ”。
          </div>
          <WhiteSpace />
          <div>
            2、关注“<span className="color-danger">爱玩SDK</span>”公众号。
          </div>
          <WhiteSpace />
          <div>
            3、点击“<span className="color-danger">兑换红包</span>”菜单。
          </div>
          <WhiteSpace />
          <div>4、输入绑定码，进行绑定。</div>
          <WhiteSpace />
          <div>5、绑定后返回游戏，即刻开启红包之旅。</div>
          <WhiteSpace size="xl" />
          <Flex>
            绑定码：
            <input
              style={{ width: '9em' }}
              className="pure-text color-danger text-md"
              defaultValue={accountMemo.bind_code}
              spellCheck={false}
              readOnly
            />
            <Clipboard value={accountMemo.bind_code}>复制</Clipboard>
          </Flex>
          <WhiteSpace size="xl" />
          <Flex justify="center">
            <Button
              style={{
                width: 150,
              }}
              className="round"
              type="primary"
              size="small"
              inline
              onClick={goWechat}
            >
              前往绑定
            </Button>
          </Flex>
        </div>
      </FullModal>
    </div>
  )
}

export default Account
